<div class="barcode-lookup">
  <h2 mat-dialog-title>{{ "products.lookup.title" | translate }}</h2>

  <mat-dialog-content>
    <div class="barcode-lookup__row" fxLayout="row" fxLayoutAlign="start center" style="gap: 8px;">
      <mat-form-field appearance="outline" floatLabel="always" style="flex: 1;">
        <mat-label>{{ "products.lookup.upc" | translate }}</mat-label>
        <input matInput [(ngModel)]="upc" autocomplete="off"
          placeholder="{{ 'products.lookup.upcPlaceholder' | translate }}"
          (keyup.enter)="search()">
      </mat-form-field>

      <button mat-flat-button color="primary" (click)="search()" [disabled]="loading || !upc.trim()">
        <mat-spinner *ngIf="loading" diameter="20"></mat-spinner>
        <span *ngIf="!loading">{{ "products.lookup.search" | translate }}</span>
      </button>
    </div>

    <div class="barcode-lookup__result" *ngIf="searched && !loading">
      <div *ngIf="result?.found" class="barcode-lookup__found">
        <mat-icon color="primary">check_circle</mat-icon>
        <span>{{ "products.lookup.found" | translate }}</span>
        <div class="barcode-lookup__name" *ngIf="result?.data?.prdNameEn">{{ result.data.prdNameEn }}</div>
      </div>
      <div *ngIf="!result?.found" class="barcode-lookup__notfound">
        <mat-icon>info</mat-icon>
        <span>{{ "products.lookup.notFound" | translate }}</span>
      </div>
    </div>
  </mat-dialog-content>

  <mat-dialog-actions align="end">
    <button mat-stroked-button (click)="cancel()">{{ "cancel" | translate }}</button>
    <button mat-flat-button color="primary" *ngIf="searched && result?.found" (click)="use()">
      {{ "products.lookup.use" | translate }}
    </button>
  </mat-dialog-actions>
</div>
